var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"router":true,"default-active":_vm.defaultActive}},[_c('menu-item',{attrs:{"menuList":_vm.menu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }